import { render, staticRenderFns } from "./HeadOfOperations.vue?vue&type=template&id=79fb2381"
import script from "./HeadOfOperations.vue?vue&type=script&lang=js"
export * from "./HeadOfOperations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports